/**
 * 회원가입 완료 (/m/signup/complete) — [로그인] 은 replace (완료 화면으로 되돌아오지 않게)
 * ($j.Pages.Mobile.SignupComplete / body data-page-name="SignupComplete")
 */
export default class SignupComplete {
    initialize() {
        // 가입이 끝난 화면으로 되돌아오지 않게 replace 로 이동한다
        $(function () {
            $('#next-button').on('click', function () { location.replace('/m/login'); });
        });

    }
}
